import useCarHireOfferImportantInformation from 'hooks/CarHire/useCarHireImportantInformation'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineCoinsIcon from 'LuxKit/Icons/line/LineCoinsIcon'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import CarHireImportantInformationList from '../CarHireOfferTile/CarHireImportantInformationList'
import Divider from 'LuxKit/Divider'
import styled from 'styled-components'
import { rem } from 'polished'

const HeadingBlock = styled(HeadingTextBlock)`
  .variant-heading6 {
    font-size: 14px;
  }
`

const CarInfoList = styled(CarHireImportantInformationList)`
  margin: 0 !important;
`

const BannerWrapper = styled.div`
  padding: ${rem(20)} 0;
`

interface Props {
  offer: App.CarHireOffer
  pickUpDate: string
  dropOffDate: string
  pickUpTime: string
  dropOffTime: string
  onClick: () => void
  hasEnhancedProtection: boolean
}

const USDestinationsTexts = {
  thirdPartyProtectionText: 'Included as part of your rental agreement. If you or any authorised driver are involved in an accident, Third Party injury and property damage is already covered.',
  bannerText: "With Enhanced Protection, you're covered for personal possessions, accidental damages, misfuelling, and more. You can select your insurance during checkout.",
}

const allDestinationsTexts = {
  thirdPartyProtectionText: "Included as part of your protection. If you or any authorised driver cause an accident, supplier covers injury or damage to property caused by your use of the car during the rental period. It doesn't cover your injuries or damage to the rental car.",
  bannerText: "With our Enhanced Protection you're refunded for any incurred excess charges. You can select your insurance during checkout.",
}

function CarHireInsuranceLimitedProtectionInfo(props: Props) {
  const {
    offer,
    pickUpDate,
    dropOffDate,
    pickUpTime,
    dropOffTime,
    onClick,
    hasEnhancedProtection,
  } = props

  const rateOption = offer.rateOptions[0]

  const params: App.CarHireOfferImportantInformationParams = {
    pickUpLocation: {
      code: offer.pickUp.id,
      date: pickUpDate || '',
      time: pickUpTime || '',
    },
    dropOffLocation: {
      code: offer.dropOff.id,
      date: dropOffDate || '',
      time: dropOffTime || '',
    },
    reference: {
      id: rateOption.id,
      idContext: rateOption.idContext,
      type: rateOption.type,
      dateTime: rateOption.dateTime,
      url: rateOption.url,
    },
  }

  const { offerImportantInformation } = useCarHireOfferImportantInformation(params, rateOption.id)
  const hasError = Boolean(offerImportantInformation.error)
  const offerImportantInformationData = offerImportantInformation.data

  return (
    <VerticalSpacer gap={16}>
      <HeadingTextBlock variant="heading6">What's covered</HeadingTextBlock>
      <Divider kind="primary" />
      {offerImportantInformation && !!offerImportantInformationData &&
        <>
          <HeadingBlock className="limitedProtectionItemHeading" variant="heading6" startIcon={(<LineCoinsIcon size="M" />)}>Excess Fee</HeadingBlock>
          <BodyText variant="medium">
            In the case of damage to your rental car, you may be liable for the following excess:
          </BodyText>
          <CarInfoList
            offerImportantInformation={offerImportantInformationData}
            hasError={hasError}
            displayCategory="Coverage"
            showTitle={false}
          />
        </>}
      <Divider kind="primary" />
      <HeadingBlock className="limitedProtectionItemHeading" variant="heading6" startIcon={(<LineShieldCheckIcon size="M" />)}>Third Party Protection</HeadingBlock>
      <BodyText variant="medium">
        {hasEnhancedProtection && USDestinationsTexts.thirdPartyProtectionText}
        {!hasEnhancedProtection && allDestinationsTexts.thirdPartyProtectionText}
      </BodyText>
      <BannerWrapper>
        <MessageBanner
          icon={<LineShieldCheckIcon />}
          kind="promotional-primary"
          heading="Want the best cover?"
          secondaryActionButtonProps={{
            children: 'View Enhanced Protection',
            onClick,
          }}
        >
          {hasEnhancedProtection && USDestinationsTexts.bannerText}
          {!hasEnhancedProtection && allDestinationsTexts.bannerText}
        </MessageBanner>
      </BannerWrapper>

    </VerticalSpacer>
  )
}

export default CarHireInsuranceLimitedProtectionInfo
